export type FiscalYearOptionTestId =
  | typeof FISCAL_YEAR_SELECT_TEST_ID.LAST_YEAR
  | typeof FISCAL_YEAR_SELECT_TEST_ID.CURRENT_YEAR;

export const FISCAL_YEAR_SELECT_TEST_ID = {
  SELECT: 'fiscal-year-select',
  LAST_YEAR: 'fiscal-year-select-last-year',
  CURRENT_YEAR: 'fiscal-year-select-current-year',
} as const;

export const MULTI_PORTFOLIO_DEPOSIT_TEST_ID = {
  CONTINUE_BUTTON: 'multi-portfolio-deposit-continue-button',
  ACCOUNT_SELECT: 'multi-portfolio-deposit-account-select',
  SUB_ACCOUNT_ROW: 'multi-portfolio-deposit-sub-account-row',
  TOTAL_AMOUNT: 'multi-portfolio-deposit-total-amount',
  MODE_TOGGLE: 'multi-portfolio-deposit-mode',
  SCHEDULE_SELECT: 'multi-portfolio-deposit-schedule',
  STARTING: 'multi-portfolio-deposit-starting',
  SCHEDULED_DATE: 'multi-portfolio-deposit-scheduled-date',
  TRANSFER_DELAY_ALERT: 'multi-portfolio-deposit-transfer-delay-alert',
} as const;
